var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlertCard from '@/components/alert-card/AlertCard';
import { Message } from '@/models/Message';
let UserSubjectMessageForm = class UserSubjectMessageForm extends Vue {
    constructor() {
        super(...arguments);
        this.sanitizedRooms = [];
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.message = '';
        this.messages = [];
        this.rules = {
            valid: false,
            message: [(v) => !!v || 'Message is required'],
        };
        this.fileName = '';
        this.fileInput = null;
        this.file = undefined;
        this.hasFile = false;
    }
    mounted() {
        this.sanitizedRooms = this.sanitizeRooms(this.rooms);
    }
    submit() {
        if (this.message.length <= 0) {
            return;
        }
        this.isSubmitting = true;
        new Message().createBulk({
            rooms: this.sanitizedRooms,
            key: 'student.idp.subject',
            text: this.message,
            file: this.file,
        }).then((messages) => {
            this.hasFile = false;
            this.file = null;
            if (this.fileInput) {
                this.fileInput.removeAttribute('value');
                this.fileInput.setAttribute('value', '');
            }
            clearTimeout(this.takingTooLongTimeout);
            this.isTakingTooLong = false;
            this.isSubmitting = false;
            this.isSubmitted = true;
        });
    }
    clear() {
        this.isSubmitting = false;
        this.isTakingTooLong = false;
        this.message = '';
    }
    close() {
        this.clear();
        this.$emit('input', false);
    }
    isSubmittingChanged(isSubmitting, wasUploading) {
        if (isSubmitting) {
            this.takingTooLongTimeout = setTimeout(() => {
                this.isTakingTooLong = true;
            }, 30000);
        }
        else {
            this.isTakingTooLong = false;
            clearTimeout(this.takingTooLongTimeout);
        }
    }
    inputChanged(event) {
        this.fileInput = event.target;
        const files = this.fileInput.files;
        if (files === null || !files.length) {
            return;
        }
        this.file = files[0];
        this.fileName = files[0].name;
        this.hasFile = true;
    }
    isSubmittedChanged(isSubmitted, wasSubmitted) {
        if (isSubmitted) {
            this.$emit('message-changed');
        }
    }
    sanitizeRooms(rooms) {
        rooms.forEach((room, index) => {
            rooms[index] = room.replace('chat.', '').replace('private-', '');
        });
        return rooms;
    }
    roomsChanged(rooms) {
        this.sanitizedRooms = this.sanitizeRooms(rooms);
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], UserSubjectMessageForm.prototype, "rooms", void 0);
__decorate([
    Watch('isSubmitting'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], UserSubjectMessageForm.prototype, "isSubmittingChanged", null);
__decorate([
    Watch('isSubmitted'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], UserSubjectMessageForm.prototype, "isSubmittedChanged", null);
__decorate([
    Watch('rooms'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], UserSubjectMessageForm.prototype, "roomsChanged", null);
UserSubjectMessageForm = __decorate([
    Component({
        components: {
            AlertCard,
        },
    })
], UserSubjectMessageForm);
export default UserSubjectMessageForm;
